module.exports = __webpack_public_path__ + "logo_dental_principal.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/new_layout/logo_dental_principal.svg
 ** module id = 1145
 ** module chunks = 0
 **/